export function getUserInitial(user) {
  const displayName = user?.username?.trim() || user?.email?.trim() || '用户'
  return Array.from(displayName)[0].toLocaleUpperCase()
}
